import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import classNames from 'classnames';

import { Typography } from '@material-ui/core';
import FormHelperText from '@material-ui/core/FormHelperText';

import { currencyFormatter } from 'utils/prices/formatter';

import { Input } from 'components';

import useStyles from './styles';

const Errors = ({ submitFailed, error }) => {
  const classes = useStyles();
  const [t] = useTranslation();

  if (!submitFailed || !error) return null;

  const exceedError = error.indexOf('The number of Units can’t exceed') === 0;

  if (exceedError) {
    const errorSplit = error.split(' ');
    const errorLength = errorSplit.length;
    const staticError = errorSplit.slice(0, -1).join(' ');
    return (
      <FormHelperText className={classNames(classes.error)} error>
        {t(staticError, { number: errorSplit[errorLength - 1] })}
      </FormHelperText>
    );
  }

  return (
    <FormHelperText className={classNames(classes.error)} error>
      {t(error)}
    </FormHelperText>
  );
};

export const RentalVisitors = ({
  fields,
  title,
  wrapperClass,
  itemClass,
  titleClass,
  currency,
  meta: { submitFailed, error }
}) => {


  const [t] = useTranslation();
  const [isZoomed, setIsZoomed] = useState(false);
  const classes = useStyles({ isZoomed });

  const handleFocus = () => {
    setIsZoomed(true); 
};

const handleBlur = () => {
    setIsZoomed(false); 
};


  if (!fields.length) return null;

  return (
    <div className={wrapperClass}>
      <Typography
        variant="h3"
        classes={{
          root: classNames(classNames(classes.sectionTitleIndent, titleClass))
        }}
      >
        {t(title)}
      </Typography>
      <div className={classes.wrapper}>
        {fields.map((field, index) => {
          const item = fields.get(index);
          const price = `${currencyFormatter(item[currency])}`;

          return (
            <div className={classNames(classes.item, itemClass)} key={index}>
              {item.availableUnits && (
                <div className={classes.itemColumn}>
                {t('No. of units')}: {item.availableUnits}
              </div>
              )}
              <div
                className={classNames(
                  classes.itemColumn,
                  classes.currencyColumn
                )}
              >
                <span className={classes.currency}>{currency}</span> {price}
              </div>
              <div className={classes.itemColumn}>
                <Field
                  name={`${field}.availableUnits`}
                  isOnlyNumber={true}
                  maxLength={9}
                  isHiddenErrorMsg={true}
                  className={`${classes.field} ${isZoomed ? 'zoomed' : ''}`}  
                  component={Input}
                  onFocus={handleFocus}
                  onBlur={handleBlur} 
                />
                
              </div>
            </div>
          );
        })}
      </div>
      <Errors error={error} submitFailed={submitFailed} />
    </div>
  );
};

export default RentalVisitors;
